import { createLoader } from '@meteor/data-hooks';
import { useEffect, useState } from 'react';
import { withAuth } from '../../user';
import { organizationClient } from '../client';

export let organizationInvitesLoader = createLoader({
  name: 'organizationInvites',
  fetch: (i: { organizationId: string }) =>
    withAuth(() => organizationClient.organizationInvite.list(i)),
  mutators: {
    createByEmail: (
      i: {
        email: string;
        message?: string;
        role: 'member' | 'admin';
      },
      { input: { organizationId } }
    ) =>
      withAuth(() =>
        organizationClient.organizationInvite.createByEmail({
          organizationId,
          ...i
        })
      ),

    delete: (i: { organizationInviteId: string }, { input: { organizationId } }) =>
      withAuth(() =>
        organizationClient.organizationInvite.delete({
          organizationId,
          ...i
        })
      )
  }
});

export let useOrganizationInvites = (organizationId: string | null) => {
  let member = organizationInvitesLoader.use(organizationId ? { organizationId } : null);

  return {
    ...member,
    createByEmailMutator: member.useMutator('createByEmail'),
    deleteMutator: member.useMutator('delete')
  };
};

export let useOrganizationInviteLink = (organizationId: string | null) => {
  let [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (url || !organizationId) return;

    (async () => {
      let res = await withAuth(() =>
        organizationClient.organizationInvite.createLink({ organizationId })
      );

      setUrl(res.inviteLink.url);
    })().catch(console.error);
  }, [url, organizationId]);

  return url;
};
